import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/accordion/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/alert/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/avatar/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/breadcrumb/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/button/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/card/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/checkbox/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/close-button/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/color-mode/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/control-box/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/counter/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/css-reset/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/editable/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/focus-lock/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/form-control/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/hooks/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/icon/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/image/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/input/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/layout/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/media-query/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/menu/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/modal/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/number-input/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/pin-input/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/popover/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/popper/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/portal/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/progress/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/radio/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/react-env/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["ChakraBaseProvider","ChakraProvider"] */ "/app/node_modules/@chakra-ui/react/dist/chunk-QAITB7GG.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/select/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/skeleton/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/skip-nav/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/slider/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/spinner/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/stat/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/stepper/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/switch/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["styled","toCSSObject"] */ "/app/node_modules/@chakra-ui/system/dist/chunk-5PL47M24.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["getToken","useChakra","useToken"] */ "/app/node_modules/@chakra-ui/system/dist/chunk-7FWEOSAE.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useComponentStyles__unstable","useMultiStyleConfig","useStyleConfig"] */ "/app/node_modules/@chakra-ui/system/dist/chunk-DMO4EI7P.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["shouldForwardProp"] */ "/app/node_modules/@chakra-ui/system/dist/chunk-FDQH4LQI.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/system/dist/chunk-I77ZCDZJ.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["CSSVars","GlobalStyle","StylesProvider","ThemeProvider","createStylesContext","useStyles"] */ "/app/node_modules/@chakra-ui/system/dist/chunk-MFVQSVQB.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useTheme"] */ "/app/node_modules/@chakra-ui/system/dist/chunk-UIGT7YZF.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["chakra"] */ "/app/node_modules/@chakra-ui/system/dist/chunk-ZHQNHOQS.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["forwardRef"] */ "/app/node_modules/@chakra-ui/system/dist/chunk-ZJJGQIVY.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/table/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/tabs/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/tag/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/textarea/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/tooltip/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/transition/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/visually-hidden/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-toastify/dist/ReactToastify.min.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/styles/fonts/index.js\",\"import\":\"Noto_Sans_TC\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-noto-sans-tc\",\"display\":\"swap\"}],\"variableName\":\"noto_sans_tc\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/styles/fonts/index.js\",\"import\":\"Poppins\",\"arguments\":[{\"weight\":[\"100\",\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"800\",\"900\"],\"subsets\":[\"latin\"],\"variable\":\"--font-poppins\",\"display\":\"swap\"}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager", webpackExports: ["AppierServiceWorker","AppierProductViewed"] */ "/app/src/components/Appier/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/CustomerServiceButton/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/DevMember/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ScrollRestore/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/TranslateCrashGuard/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/UtmTracker/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/providers/ChakraProvider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalContextProvider"] */ "/app/src/providers/GlobalContextProvider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PxPayPlusProvider"] */ "/app/src/providers/PxPayPlusProvider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/providers/QueryClientProvider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RecaptchaProvider"] */ "/app/src/providers/RecaptchaProvider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/providers/ToastProvider/index.tsx");
